(function() {
    var slider = document.getElementById('gallery-slider');
    var dots = document.querySelectorAll('#gallery-dots .product-gallery__dot');
    var thumbs = document.querySelectorAll('#gallery-thumbs .product-gallery__thumb');
    var prevBtn = document.getElementById('gallery-prev');
    var nextBtn = document.getElementById('gallery-next');
    var slides = slider ? slider.querySelectorAll('.product-gallery__slide') : [];
    var currentIndex = 0;

    function goToSlide(index) {
      if (!slider || index < 0 || index >= slides.length) return;
      currentIndex = index;
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      updateIndicators(index);
    }

    function updateIndicators(index) {
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); });
      thumbs.forEach(function(t, i) {
        t.classList.toggle('is-active', i === index);
        if (i === index) t.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    if (slider) {
      var scrollTimeout;
      slider.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          var scrollLeft = slider.scrollLeft;
          var slideWidth = slider.offsetWidth;
          var newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            updateIndicators(currentIndex);
          }
        }, 50);
      }, { passive: true });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.index)); });
    });
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() { goToSlide(parseInt(this.dataset.index)); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentIndex + 1); });

    /* ── Share: native share sheet on mobile, copy-link fallback ── */
    var shareBtn = document.getElementById('product-share');
    if (shareBtn) {
      shareBtn.addEventListener('click', function() {
        var url = shareBtn.getAttribute('data-share-url');
        var title = shareBtn.getAttribute('data-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function() {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function() { flashShareCopied(); }).catch(function() { window.prompt('Copy this link', url); });
        } else {
          window.prompt('Copy this link', url);
        }
      });
    }
    function flashShareCopied() {
      var old = shareBtn.querySelector('.product-info__share-copied');
      if (old) return;
      var t = document.createElement('span');
      t.className = 'product-info__share-copied';
      t.textContent = 'Link copied';
      shareBtn.appendChild(t);
      setTimeout(function() { t.remove(); }, 1600);
    }

    var minusBtn = document.getElementById('qty-minus');
    var plusBtn = document.getElementById('qty-plus');
    var meterInput = document.getElementById('meter-input');

    function syncAtcWithStepper() {
      if (!meterInput || !addBtn || addBtn.disabled) return;
      var qty = parseInt(meterInput.value) || 1;
      var unit = meterInput.dataset.unit || '';
      var label = unit ? 'Add ' + qty + ' ' + unit : (qty > 1 ? 'Add ' + qty + ' to cart' : 'Add to cart');
      addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> ' + label;
      var pForm = document.getElementById('product-form');
      if (pForm) pForm.dataset.qtyPresetDefaultAtcLabel = addBtn.innerHTML;
    }

    function meterStockMax() {
      var m = parseInt(meterInput.getAttribute('max'), 10);
      return m || 9999;
    }
    var meterStockPulseTimer = null;
    function flashStockMsg() {
      // The persistent stock line already says the number — just pulse it for feedback.
      var el = document.getElementById('product-stock');
      if (!el) return;
      el.classList.remove('product-stock--pulse');
      void el.offsetWidth;
      el.classList.add('product-stock--pulse');
      clearTimeout(meterStockPulseTimer);
      meterStockPulseTimer = setTimeout(function() { el.classList.remove('product-stock--pulse'); }, 700);
    }

    if (minusBtn && plusBtn && meterInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(meterInput.value) || 1;
        if (val > 1) meterInput.value = val - 1;
        syncAtcWithStepper();
      });
      plusBtn.addEventListener('click', function() {
        var val = parseInt(meterInput.value) || 1;
        var max = meterStockMax();
        if (val + 1 > max) { meterInput.value = max; flashStockMsg(); }
        else { meterInput.value = val + 1; }
        syncAtcWithStepper();
      });
      meterInput.addEventListener('change', function() {
        var val = parseInt(this.value);
        if (!val || val < 1) this.value = 1;
        var max = meterStockMax();
        if (parseInt(this.value, 10) > max) { this.value = max; flashStockMsg(); }
        syncAtcWithStepper();
      });
    }

    /* ── Quantity Presets v2 ── */
    (function() {
      var BLOCK_SEL = '[data-quantity-presets-block]';
      var DEFAULT_API = 'https://us-central1-fvs-workspace.cloudfunctions.net/app';

      function getForm(block) {
        return block.closest('form#product-form') || document.getElementById('product-form');
      }

      function parseVData(block) {
        var el = block.querySelector('[data-qty-preset-variants]');
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch(e) { return null; }
      }

      function readVariantId(form) {
        var inp = form.querySelector('input[name="id"]');
        return inp ? inp.value : '';
      }

      function getVariantById(vd, vid) {
        if (!vd || !vd.variants) return null;
        for (var i = 0; i < vd.variants.length; i++) {
          if (String(vd.variants[i].id) === String(vid)) return vd.variants[i];
        }
        return null;
      }

      function setVariantInput(form, vid) {
        var inp = form.querySelector('input[name="id"]');
        if (!inp || !vid) return;
        inp.value = String(vid);
        inp.dispatchEvent(new Event('input', {bubbles:true}));
        inp.dispatchEvent(new Event('change', {bubbles:true}));
      }

      function setQuantity(form, qty) {
        var inp = form.querySelector('input[name="quantity"]');
        if (!inp) return;
        inp.value = String(Math.max(1, parseInt(qty) || 1));
        inp.dispatchEvent(new Event('input', {bubbles:true}));
        inp.dispatchEvent(new Event('change', {bubbles:true}));
      }

      function ensureHidden(form, name) {
        var inp = form.querySelector('input[name="' + name + '"]');
        if (!inp) {
          inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = name;
          form.appendChild(inp);
        }
        return inp;
      }

      function setHidden(form, name, val) {
        var v = (val || '').toString().trim();
        var existing = form.querySelector('input[name="' + name + '"]');
        if (!v) { if (existing) existing.remove(); return; }
        ensureHidden(form, name).value = v;
      }

      function clearProps(form) {
        ['properties[Cut Length]', 'properties[Requested Title]', 'properties[Preset Label]', 'properties[_Base Variant ID]'].forEach(function(n) {
          var inp = form.querySelector('input[name="' + n + '"]');
          if (inp) inp.remove();
        });
      }

      function clearPending(form) {
        delete form.dataset.qtyPresetPendingMapped;
        delete form.dataset.qtyPresetPendingBaseVariantId;
        delete form.dataset.qtyPresetPendingMeters;
        delete form.dataset.qtyPresetPendingLabel;
        delete form.dataset.qtyPresetPendingUnitLabel;
        delete form.dataset.qtyPresetPendingFabricName;
        delete form.dataset.qtyPresetPendingBaseVariantSku;
      }

      function restoreBase(form) {
        var baseId = form.dataset.qtyPresetBaseVariantId;
        var mappedId = form.dataset.qtyPresetMappedVariantId;
        var current = readVariantId(form);
        if (baseId && mappedId && String(current) === String(mappedId)) {
          setVariantInput(form, baseId);
        }
        delete form.dataset.qtyPresetBaseVariantId;
        delete form.dataset.qtyPresetMappedVariantId;
      }

      function resetAtcLabel(form) {
        var atcBtn = form.querySelector('#btn-add-to-cart');
        if (!atcBtn) return;
        var def = form.dataset.qtyPresetDefaultAtcLabel;
        if (def) atcBtn.innerHTML = def;
        delete form.dataset.qtyPresetSelectedLength;
      }

      function setAtcLabel(form, meters, unit) {
        var atcBtn = form.querySelector('#btn-add-to-cart');
        if (!atcBtn) return;
        if (!form.dataset.qtyPresetDefaultAtcLabel) {
          form.dataset.qtyPresetDefaultAtcLabel = atcBtn.innerHTML;
        }
        var m = (meters || '').trim();
        if (!m) { atcBtn.innerHTML = form.dataset.qtyPresetDefaultAtcLabel; return; }
        atcBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add ' + m + (unit ? ' ' + unit : '');
        form.dataset.qtyPresetSelectedLength = m;
      }

      function normalizeLen(raw) {
        var t = (raw || '').toString().trim().replace(',', '.').split(/\s+/)[0] || '';
        if (!t) return '';
        var n = Number(t);
        if (!isFinite(n) || n <= 0) return t;
        if (Number.isInteger(n)) return String(n);
        return String(n);
      }

      function isIntLen(raw) {
        var n = Number(normalizeLen(raw));
        return isFinite(n) && Math.abs(n - Math.round(n)) < 0.00001;
      }

      function buildSkuCandidates(baseSku, meters) {
        var bs = (baseSku || '').trim();
        var nm = normalizeLen(meters);
        if (!bs || !nm) return [];
        var c = [];
        c.push((bs + '-' + nm + 'M').toUpperCase());
        var num = Number(nm);
        if (isFinite(num)) {
          c.push((bs + '-' + num.toFixed(1) + 'M').toUpperCase());
          c.push((bs + '-' + num.toFixed(2) + 'M').toUpperCase());
        }
        return c;
      }

      function findMapped(vd, baseV, meters) {
        if (!vd || !vd.variants || !baseV || !baseV.sku) return null;
        var targets = buildSkuCandidates(baseV.sku, meters);
        var baseSku = (baseV.sku || '').trim().toUpperCase();
        var targetM = Number(normalizeLen(meters));
        for (var i = 0; i < vd.variants.length; i++) {
          var c = vd.variants[i];
          if (!c.available) continue;
          var cs = (c.sku || '').trim().toUpperCase();
          if (!cs) continue;
          if (targets.indexOf(cs) >= 0) return c;
          if (!baseSku || cs.indexOf(baseSku + '-') !== 0) continue;
          var suffix = cs.slice(baseSku.length + 1);
          var m = suffix.match(/^([0-9]+(?:[.,][0-9]+)?)\s*(?:M|MTR|METER|METERS)?$/);
          if (!m || !m[1] || !isFinite(targetM)) continue;
          var cm = Number(m[1].replace(',', '.'));
          if (isFinite(cm) && Math.abs(cm - targetM) < 0.001) return c;
        }
        return null;
      }

      function setActive(block, activeBtn) {
        block.querySelectorAll('[data-qty-preset-btn]').forEach(function(b) {
          var isA = b === activeBtn;
          b.classList.toggle('is-active', isA);
          b.setAttribute('aria-pressed', isA ? 'true' : 'false');
        });
      }

      function applyCategoryFilter(block, category) {
        var sel = (category || '').trim();
        var tabs = block.querySelectorAll('[data-qty-preset-category-tab]');
        var btns = block.querySelectorAll('[data-qty-preset-btn]');
        var multiCat = tabs.length > 1;
        btns.forEach(function(b) {
          var bc = (b.dataset.qtyPresetCategory || '').trim();
          var show = multiCat ? (!!sel && bc === sel) : (!sel || bc === sel);
          b.hidden = !show;
        });
        block.dataset.qtyPresetActiveCategory = sel;
        tabs.forEach(function(t) {
          var isA = (t.dataset.category || '').trim() === sel;
          t.classList.toggle('is-active', isA);
          t.setAttribute('aria-selected', isA ? 'true' : 'false');
        });
        var helper = block.querySelector('[data-qty-preset-helper]');
        if (helper) helper.hidden = multiCat ? !sel : false;
      }

      function syncStepperVisibility(block) {
        var accordion = block.querySelector('[data-qty-preset-accordion]');
        if (!accordion) return;
        var stepper = block.closest('.product-info').querySelector('.product-block--quantity_stepper');
        if (!stepper) return;
        stepper.style.display = accordion.open ? 'none' : '';
      }

      // presets that need more meters than are actually in stock can't be fulfilled —
      // grey them out and block selection. Stock ceiling comes from the same #meter-input
      // max the stepper itself already enforces (server-set from current_variant's
      // inventory_quantity; blank/unlimited when inventory isn't tracked for this variant).
      function applyStockLimit(block) {
        var mi = document.getElementById('meter-input');
        var maxAttr = mi ? mi.getAttribute('max') : null;
        var max = maxAttr ? parseFloat(maxAttr) : NaN;
        block.querySelectorAll('[data-qty-preset-btn]').forEach(function(b) {
          var len = parseFloat(b.dataset.qtyPresetLength);
          var overStock = isFinite(max) && isFinite(len) && len > max;
          b.classList.toggle('is-stock-limited', overStock);
          b.disabled = overStock;
          b.setAttribute('aria-disabled', overStock ? 'true' : 'false');
        });
      }

      function getApiBase(block) {
        return ((block.dataset.presetApiBase || '').trim() || DEFAULT_API).replace(/\/+$/, '');
      }

      function setLoading(btn, loading) {
        btn.classList.toggle('is-loading', !!loading);
        btn.disabled = !!loading;
      }

      function buildPayload(block, btn, form, vd) {
        var vid = form.dataset.qtyPresetBaseVariantId || readVariantId(form);
        var variant = getVariantById(vd, vid);
        var meters = (btn.dataset.qtyPresetLength || '').trim();
        var label = (btn.dataset.qtyPresetLabel || '').trim();
        var unit = (block.dataset.unitLabel || 'Meter').trim();
        var optIdx = Number(vd ? vd.fabric_option_index : -1);
        var varFabric = (Number.isInteger(optIdx) && optIdx >= 0 && variant) ? (variant.options[optIdx] || '') : '';
        var fabricName = varFabric || (block.dataset.defaultFabricName || '').trim();
        var mapped = findMapped(vd, variant, meters);
        return {
          baseVariantId: vid,
          baseVariantSku: variant ? (variant.sku || '') : '',
          meters: meters,
          metersNumber: Number(normalizeLen(meters)),
          label: label,
          unitLabel: unit,
          fabricName: fabricName,
          mappedVariantId: mapped ? String(mapped.id) : ''
        };
      }

      function applyInteger(form, payload) {
        var whole = Math.max(1, Math.round(payload.metersNumber));
        clearPending(form);
        clearProps(form);
        restoreBase(form);
        setVariantInput(form, payload.baseVariantId);
        setQuantity(form, whole);
        setAtcLabel(form, String(whole), payload.unitLabel);
      }

      function applyMapped(form, payload) {
        clearPending(form);
        clearProps(form);
        setQuantity(form, 1);
        setHidden(form, 'properties[Cut Length]', payload.meters + ' ' + payload.unitLabel);
        setHidden(form, 'properties[Preset Label]', payload.label);
        setHidden(form, 'properties[_Base Variant ID]', payload.baseVariantId);
        form.dataset.qtyPresetBaseVariantId = String(payload.baseVariantId);
        form.dataset.qtyPresetMappedVariantId = String(payload.mappedVariantId);
        setVariantInput(form, payload.mappedVariantId);
        setAtcLabel(form, payload.meters, payload.unitLabel);
      }

      async function ensurePresetVariant(block, payload) {
        var api = getApiBase(block);
        var res = await fetch(api + '/api/v1/shopify/preset-variant-ensure', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          credentials: 'omit',
          body: JSON.stringify({
            variantId: payload.baseVariantId,
            cutLength: payload.meters,
            presetLabel: payload.label,
            unitLabel: payload.unitLabel,
            fabricName: payload.fabricName
          })
        });
        var data = await res.json().catch(function() { return {}; });
        if (!res.ok || !data.success) throw new Error(data.message || 'Unable to prepare preset variant.');
        return String(data.variant ? (data.variant.legacyResourceId || data.variant.id) : (data.variantId || '')).trim();
      }

      async function handlePresetClick(btn) {
        var block = btn.closest(BLOCK_SEL);
        if (!block) return;
        var form = getForm(block);
        if (!form) return;
        var vd = parseVData(block);
        var payload = buildPayload(block, btn, form, vd);
        if (!payload.meters || !payload.baseVariantId) return;

        clearProps(form);
        restoreBase(form);

        if (isIntLen(payload.meters)) {
          applyInteger(form, payload);
          setActive(block, btn);
          return;
        }

        if (payload.mappedVariantId) {
          applyMapped(form, payload);
          setActive(block, btn);
          return;
        }

        clearProps(form);
        restoreBase(form);
        setVariantInput(form, payload.baseVariantId);
        setQuantity(form, 1);
        form.dataset.qtyPresetPendingMapped = 'true';
        form.dataset.qtyPresetPendingBaseVariantId = payload.baseVariantId;
        form.dataset.qtyPresetPendingMeters = payload.meters;
        form.dataset.qtyPresetPendingLabel = payload.label;
        form.dataset.qtyPresetPendingUnitLabel = payload.unitLabel;
        form.dataset.qtyPresetPendingFabricName = payload.fabricName;
        form.dataset.qtyPresetPendingBaseVariantSku = payload.baseVariantSku;
        setAtcLabel(form, payload.meters, payload.unitLabel);
        setActive(block, btn);
      }

      document.addEventListener('click', function(e) {
        var infoBtn = e.target.closest('.qpv2__info-btn');
        if (infoBtn) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('.qpv2__info-btn.is-open').forEach(function(n) { if (n !== infoBtn) n.classList.remove('is-open'); });
          infoBtn.classList.toggle('is-open');
          return;
        }
        document.querySelectorAll('.qpv2__info-btn.is-open').forEach(function(n) { n.classList.remove('is-open'); });

        var catTab = e.target.closest('[data-qty-preset-category-tab]');
        if (catTab) {
          e.preventDefault();
          var block = catTab.closest(BLOCK_SEL);
          if (block) {
            var clicked = (catTab.dataset.category || '').trim();
            var active = (block.dataset.qtyPresetActiveCategory || '').trim();
            applyCategoryFilter(block, clicked === active ? '' : clicked);
          }
          return;
        }

        var presetBtn = e.target.closest('[data-qty-preset-btn]');
        if (presetBtn) {
          e.preventDefault();
          if (presetBtn.disabled || presetBtn.classList.contains('is-stock-limited')) return;
          handlePresetClick(presetBtn);
        }
      });

      document.addEventListener('toggle', function(e) {
        var acc = e.target;
        if (!(acc instanceof HTMLDetailsElement) || !acc.matches('[data-qty-preset-accordion]')) return;
        var block = acc.closest(BLOCK_SEL);
        if (!block) return;

        if (!acc.open) {
          var form = getForm(block);
          if (form && form.dataset.qtyPresetSelectedLength) {
            restoreBase(form);
            clearProps(form);
            clearPending(form);
            resetAtcLabel(form);
            setActive(block, null);
            if (typeof syncAtcWithStepper === 'function') syncAtcWithStepper();
          }
        }

        syncStepperVisibility(block);
      }, true);

      var productForm = document.getElementById('product-form');
      if (productForm) {
        productForm.addEventListener('submit', function(e) {
          var form = e.target;
          var bypass = form.dataset.qtyPresetBypassPending === 'true';
          if (bypass) {
            delete form.dataset.qtyPresetBypassPending;
            return;
          }

          if (form.dataset.qtyPresetPendingMapped === 'true') {
            e.preventDefault();
            e.stopPropagation();

            var scope = form.closest('.product-info') || document;
            var block = scope.querySelector(BLOCK_SEL);
            var activeBtn = block ? block.querySelector('[data-qty-preset-btn].is-active') : null;
            var pending = {
              baseVariantId: (form.dataset.qtyPresetPendingBaseVariantId || '').trim(),
              meters: (form.dataset.qtyPresetPendingMeters || '').trim(),
              label: (form.dataset.qtyPresetPendingLabel || '').trim(),
              unitLabel: (form.dataset.qtyPresetPendingUnitLabel || '').trim() || 'Meter',
              fabricName: (form.dataset.qtyPresetPendingFabricName || '').trim(),
              baseVariantSku: (form.dataset.qtyPresetPendingBaseVariantSku || '').trim()
            };
            if (!block || !pending.baseVariantId || !pending.meters) return;
            if (activeBtn) setLoading(activeBtn, true);

            (async function() {
              var mappedId = '';
              try { mappedId = await ensurePresetVariant(block, pending); } catch(err) { mappedId = ''; }
              if (mappedId) {
                pending.mappedVariantId = mappedId;
                applyMapped(form, pending);
                clearPending(form);
                form.dataset.qtyPresetBypassPending = 'true';
                if (activeBtn) setLoading(activeBtn, false);
                form.requestSubmit();
                return;
              }
              clearPending(form);
              if (activeBtn) setLoading(activeBtn, false);
              window.alert('Unable to prepare this fractional quantity right now. Please try again.');
            })();
            return;
          }

          var hasMapped = form.dataset.qtyPresetMappedVariantId || form.querySelector('input[name="properties[Cut Length]"]');
          if (!hasMapped) return;
          setTimeout(function() {
            restoreBase(form);
            clearProps(form);
            clearPending(form);
            resetAtcLabel(form);
            var scope = form.closest('.product-info') || document;
            scope.querySelectorAll(BLOCK_SEL).forEach(function(b) { setActive(b, null); });
          }, 300);
        }, true);
      }

      document.querySelectorAll(BLOCK_SEL).forEach(function(block) {
        var tabs = block.querySelectorAll('[data-qty-preset-category-tab]');
        applyCategoryFilter(block, tabs.length > 1 ? '' : '');
        syncStepperVisibility(block);
        applyStockLimit(block);
      });

      var atcBtn = document.getElementById('btn-add-to-cart');
      if (atcBtn && productForm && !productForm.dataset.qtyPresetDefaultAtcLabel) {
        productForm.dataset.qtyPresetDefaultAtcLabel = atcBtn.innerHTML;
      }
    })();

    document.querySelectorAll('.coupon-row__copy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var code = this.dataset.copy;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        this.classList.add('is-copied');
        this.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg>';
        var self = this;
        setTimeout(function() {
          self.classList.remove('is-copied');
          self.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>';
        }, 2000);
      });
    });

    var couponsToggle = document.getElementById('coupons-toggle');
    var couponsBlock = document.getElementById('coupons-block');
    if (couponsToggle && couponsBlock) {
      couponsToggle.addEventListener('click', function() {
        var expanded = couponsBlock.classList.toggle('is-expanded');
        var extra = couponsBlock.querySelectorAll('.coupon-row--hidden').length;
        if (expanded) {
          this.firstChild.textContent = 'Show less';
        } else {
          this.firstChild.textContent = 'View ' + extra + ' more offer' + (extra > 1 ? 's' : '');
        }
      });
    }

    var variantIdInput = document.getElementById('variant-id');
    var priceContainer = document.getElementById('product-price');
    var stickyPrice = document.getElementById('sticky-price');
    var addBtn = document.getElementById('btn-add-to-cart');
    var buyBtn = document.getElementById('btn-buy-now');
    var stickyAddBtn = document.getElementById('sticky-add-btn');
    var skuEl = document.getElementById('product-sku');
    var variantsJson = [];

    try { variantsJson = JSON.parse(document.getElementById('product-json').textContent); } catch(e) {}

    function formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return (cents / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0 });
    }

    /* ── Variant Selector v2 (Rich Cards) ── */
    (function() {
      var dataEl = document.getElementById('vsv2-data');
      var cardsEl = document.getElementById('vsv2-cards');
      var valEl = document.getElementById('vsv2-val');
      var wrapEl = document.getElementById('vsv2-wrap');
      if (!dataEl || !cardsEl) return;
      // "Show expanded variant card" block setting, off: the rich card (image,
      // quality badge, price, width pills) is hidden — but a customer still needs
      // SOME way to switch variants, so force the plain <select> path instead of
      // hiding the only control on the page.
      var forcePlainSelect = wrapEl && wrapEl.getAttribute('data-show-card') === 'false';

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

      var variants = data.variants || [];
      var selectedId = data.currentVariantId;
      var optionNames = data.optionNames || [];
      var rateUnit = (data.rateUnit || '').trim();
      var prodFabric = data.prodFabric || '';
      var prodQuality = data.prodQuality || '';
      var prodType = data.productType || '';
      var isMulti = variants.length > 1;

      function esc(s) {
        return String(s || '').replace(/[&<>"']/g, function(c) {
          return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
        });
      }

      function fmt(cents) {
        return formatMoney(cents);
      }

      function checkSvg() {
        return '<svg width="10" height="10" viewBox="0 0 12 10" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 5 4.5 8.5 11 1"/></svg>';
      }

      function isShadowSku(sku) {
        return /\d+(\.\d+)?M$/i.test(sku || '');
      }

      function getOptByName(v, name) {
        var lower = name.toLowerCase();
        for (var i = 0; i < optionNames.length; i++) {
          if (optionNames[i] && optionNames[i].toLowerCase() === lower) {
            return [v.option1, v.option2, v.option3][i] || '';
          }
        }
        return '';
      }

      function getGroupKey(v) {
        return (v.option1 || '') + '|||' + (v.option2 || '');
      }

      function resetPresets() {
        var pForm = document.getElementById('product-form');
        if (!pForm) return;
        ['properties[Cut Length]','properties[Preset Label]','properties[_Base Variant ID]'].forEach(function(n) {
          var inp = pForm.querySelector('input[name="'+n+'"]'); if (inp) inp.remove();
        });
        delete pForm.dataset.qtyPresetBaseVariantId;
        delete pForm.dataset.qtyPresetMappedVariantId;
        delete pForm.dataset.qtyPresetPendingMapped;
        delete pForm.dataset.qtyPresetPendingBaseVariantId;
        delete pForm.dataset.qtyPresetPendingMeters;
        delete pForm.dataset.qtyPresetPendingLabel;
        delete pForm.dataset.qtyPresetPendingUnitLabel;
        delete pForm.dataset.qtyPresetPendingFabricName;
        delete pForm.dataset.qtyPresetPendingBaseVariantSku;
        delete pForm.dataset.qtyPresetSelectedLength;
        var defAtc = pForm.dataset.qtyPresetDefaultAtcLabel;
        if (defAtc && addBtn) addBtn.innerHTML = defAtc;
        document.querySelectorAll('[data-quantity-presets-block]').forEach(function(bl) {
          bl.querySelectorAll('[data-qty-preset-btn]').forEach(function(b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed','false');
          });
        });
      }

      function normFabric(s) {
        return (s || '').replace(/[\s\-_]+/g, '').toLowerCase();
      }

      function filterDescription(v) {
        var body = document.getElementById('product-desc-body');
        if (!body) return;
        var h6s = body.querySelectorAll('h6');
        if (!h6s.length) return;

        var fabricName = v.fabric || getOptByName(v, 'fabric') || getOptByName(v, 'size') || '';
        var normSelected = normFabric(fabricName);

        h6s.forEach(function(h6) {
          var txt = (h6.textContent || '').replace(/^#/, '');
          var parts = txt.split('-');
          var h6Fabric = parts.length >= 2 ? parts.slice(1, -1).join('-') : parts[0] || '';
          var normH6 = normFabric(h6Fabric);

          var show = !normSelected || normH6 === normSelected;
          h6.style.display = show ? '' : 'none';
          var el = h6.nextElementSibling;
          while (el && el.tagName !== 'H6' && el.tagName !== 'H3') {
            el.style.display = show ? '' : 'none';
            el = el.nextElementSibling;
          }
        });
      }

      function selectVariant(v) {
        selectedId = v.id;
        variantIdInput.value = v.id;
        // notify anything listening for variant changes on this input (ladder-pricing
        // v1/v2, bxgy-teaser, bxgy-reward-card all listen for this) — previously never
        // fired here, so those components silently went stale when switching fabric
        // via this selector (only worked when changed through other paths).
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));

        resetPresets();

        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(null, '', u.toString());
        } catch(e) {}

        if (skuEl) {
          var baseSku = v.sku || '';
          if (baseSku && !isShadowSku(baseSku)) {
            skuEl.textContent = 'SKU: ' + baseSku;
            skuEl.style.display = '';
          } else {
            skuEl.style.display = 'none';
          }
        }

        if (v.available) {
          addBtn.disabled = false;
          if (typeof syncAtcWithStepper === 'function') { syncAtcWithStepper(); }
          else { addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add 1 Meter'; }
          if (stickyAddBtn) { stickyAddBtn.disabled = false; stickyAddBtn.textContent = 'Add to Cart'; }
          if (buyBtn) buyBtn.style.display = '';
        } else {
          addBtn.disabled = true;
          addBtn.innerHTML = 'Sold Out';
          if (stickyAddBtn) { stickyAddBtn.disabled = true; stickyAddBtn.textContent = 'Sold Out'; }
          if (buyBtn) buyBtn.style.display = 'none';
        }

        var priceHtml = '';
        var matchedFull = variantsJson.find(function(vf) { return String(vf.id) === String(v.id); });
        var cp = matchedFull ? matchedFull.compare_at_price : v.compare_at_price;
        if (cp && cp > v.price) {
          var savePct = Math.round((cp - v.price) / cp * 100);
          priceHtml = '<span class="product-info__price-compare">' + formatMoney(cp) + '</span>' +
                      '<span class="product-info__price-sale">' + formatMoney(v.price) + '</span>' +
                      '<span class="product-info__price-save">Save ' + savePct + '%</span>';
        } else {
          priceHtml = '<span class="product-info__price-current">' + formatMoney(v.price) + '</span>';
        }
        if (rateUnit) priceHtml += '<span class="product-info__price-unit">per ' + esc(rateUnit) + '</span>';
        if (priceContainer) priceContainer.innerHTML = priceHtml;
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);

        filterDescription(v);
        renderCards();
      }

      function getGroupData(group) {
        var representative = group.variants[0];
        var selectedInGroup = group.variants.find(function(v) { return v.id === selectedId; });
        var hasMultipleWidths = group.variants.length > 1;

        var qualityVal = representative.quality || getOptByName(representative, 'quality') || prodQuality || '';
        var quality = qualityVal ? qualityVal.toUpperCase() : '';
        var fabric = representative.fabric || getOptByName(representative, 'fabric') || getOptByName(representative, 'size') || '';
        if (!fabric && optionNames.filter(Boolean).length === 1) fabric = representative.option1 || '';
        if (!fabric) fabric = prodFabric || prodType || '';
        if (fabric.toLowerCase() === 'default title') {
          fabric = getOptByName(representative, 'fabric') || getOptByName(representative, 'size') || prodFabric || prodType || '';
        }

        var activeVariant = selectedInGroup || representative;
        var detail = [];
        var skuVal = (activeVariant.sku && !isShadowSku(activeVariant.sku)) ? activeVariant.sku : '';
        if (skuVal) detail.push(skuVal);
        if (activeVariant.gsm) detail.push(activeVariant.gsm + ' GSM');
        if (!hasMultipleWidths && activeVariant.width) detail.push(activeVariant.width);

        return {
          representative: representative,
          selectedInGroup: selectedInGroup,
          isSel: !!selectedInGroup,
          hasMultipleWidths: hasMultipleWidths,
          quality: quality,
          fabric: fabric,
          activeVariant: activeVariant,
          detail: detail,
          sku: skuVal,
          isOos: !activeVariant.available
        };
      }

      function buildCard(group, gd, isSingle, unitHtml) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vsv2__card' + (gd.isSel ? ' is-sel' : '') + (gd.isOos ? ' is-oos' : '') + (isSingle ? ' is-sel is-static' : '');
        if (gd.isOos) btn.disabled = true;
        btn.setAttribute('aria-pressed', gd.isSel ? 'true' : 'false');

        var metaParts = [];
        if (gd.sku) metaParts.push('<span class="vsv2__sku" data-copy-sku="' + esc(gd.sku) + '" title="Click to copy SKU">' + esc(gd.sku) + '</span>');
        var otherDetail = gd.detail.filter(function(d) { return d !== gd.sku; });
        // each detail segment (e.g. "110 CM | 43 Inch") wrapped nowrap so a line
        // break can only happen BETWEEN segments (at the " · "), never inside one
        otherDetail.forEach(function(d) {
          metaParts.push('<span class="vsv2__meta-seg">' + esc(d) + '</span>');
        });
        var metaHtml = metaParts.length ? '<span class="vsv2__meta">' + metaParts.join(' · ') + '</span>' : '';

        var html =
          (gd.quality ? '<span class="vsv2__quality">' + esc(gd.quality) + '</span>' : '') +
          '<span class="vsv2__name">' + esc(gd.fabric) + '</span>' +
          metaHtml +
          (gd.isOos ? '<span class="vsv2__oos-badge">Out of stock</span>' : '') +
          '<span class="vsv2__price">' + fmt(gd.activeVariant.price) + unitHtml + '</span>' +
          '<span class="vsv2__check" aria-hidden="true">' + checkSvg() + '</span>';

        if (gd.hasMultipleWidths && gd.isSel) {
          html += '<div class="vsv2__widths">';
          html += '<span class="vsv2__width-label">Width:</span>';
          group.variants.forEach(function(wv) {
            var widthVal = wv.width || wv.option3 || '';
            if (!widthVal) return;
            var isActiveWidth = wv.id === selectedId;
            html += '<button type="button" class="vsv2__width-chip' + (isActiveWidth ? ' is-active' : '') + '" data-variant-id="' + wv.id + '">' + esc(widthVal) + '</button>';
          });
          html += '</div>';
        }

        btn.innerHTML = html;

        if (!isSingle && !gd.isOos) {
          btn.addEventListener('click', function(e) {
            if (e.target.closest('.vsv2__width-chip')) return;
            if (e.target.closest('[data-copy-sku]')) return;
            if (!gd.isSel) selectVariant(gd.representative);
          });
        }

        var skuEl = btn.querySelector('[data-copy-sku]');
        if (skuEl) {
          skuEl.addEventListener('click', function(e) {
            e.stopPropagation();
            var sku = this.dataset.copySku;
            if (navigator.clipboard) {
              navigator.clipboard.writeText(sku);
            }
            this.classList.add('is-copied');
            var self = this;
            setTimeout(function() { self.classList.remove('is-copied'); }, 1200);
            if (!gd.isSel && !isSingle && !gd.isOos) selectVariant(gd.representative);
          });
        }

        if (gd.hasMultipleWidths && gd.isSel) {
          btn.querySelectorAll('.vsv2__width-chip').forEach(function(chip) {
            chip.addEventListener('click', function(e) {
              e.stopPropagation();
              var vid = parseInt(this.dataset.variantId, 10);
              var wv = group.variants.find(function(v) { return v.id === vid; });
              if (wv) selectVariant(wv);
            });
          });
        }

        return btn;
      }

      function renderCards() {
        cardsEl.innerHTML = '';
        var unitHtml = rateUnit ? '<small>per ' + esc(rateUnit) + '</small>' : '';

        var visibleVariants = variants.filter(function(v) {
          if (isShadowSku(v.sku)) return false;
          if (!v.available && v.inventory_policy === 'deny') return false;
          return true;
        });

        if (visibleVariants.length === 0) return;

        var groups = [];
        var groupMap = {};

        visibleVariants.forEach(function(v) {
          var key = getGroupKey(v);
          if (!groupMap[key]) {
            groupMap[key] = { key: key, variants: [], option1: v.option1, option2: v.option2 };
            groups.push(groupMap[key]);
          }
          groupMap[key].variants.push(v);
        });

        var isSingle = groups.length === 1 && groups[0].variants.length === 1;
        var useDropdown = groups.length > 5 || forcePlainSelect;

        if (useDropdown) {
          var selectWrap = document.createElement('div');
          selectWrap.className = 'vsv2__select-wrap';

          var select = document.createElement('select');
          select.className = 'vsv2__select';
          select.setAttribute('aria-label', 'Select fabric');

          var selGroup = null;

          groups.forEach(function(group) {
            var gd = getGroupData(group);
            var opt = document.createElement('option');
            opt.value = gd.representative.id;
            var optText = gd.fabric;
            if (gd.quality) optText = gd.quality + ' · ' + optText;
            optText += ' — ' + fmt(gd.activeVariant.price);
            if (gd.isOos) optText += ' (Out of stock)';
            opt.textContent = optText;
            if (gd.isOos) opt.disabled = true;
            if (gd.isSel) {
              opt.selected = true;
              selGroup = group;
            }
            select.appendChild(opt);
          });

          if (!selGroup) selGroup = groups[0];

          selectWrap.innerHTML = '<svg class="vsv2__select-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';
          selectWrap.insertBefore(select, selectWrap.firstChild);

          select.addEventListener('change', function() {
            var vid = parseInt(this.value, 10);
            var v = variants.find(function(v) { return v.id === vid; });
            if (v) selectVariant(v);
          });

          cardsEl.appendChild(selectWrap);

          if (!forcePlainSelect) {
            var selGd = getGroupData(selGroup);
            var card = buildCard(selGroup, selGd, false, unitHtml);
            card.className = 'vsv2__card is-display is-static';
            card.removeAttribute('aria-pressed');
            card.querySelector('.vsv2__check')?.remove();
            cardsEl.appendChild(card);
          }

        } else {
          groups.forEach(function(group) {
            var gd = getGroupData(group);
            var card = buildCard(group, gd, isSingle, unitHtml);
            cardsEl.appendChild(card);
          });
        }

        if (valEl) {
          var sv = variants.find(function(v) { return v.id === selectedId; });
          if (sv) {
            var label = sv.fabric || getOptByName(sv, 'fabric') || getOptByName(sv, 'size') || '';
            if (!label && optionNames.filter(Boolean).length === 1) label = sv.option1 || '';
            if (!label) label = prodFabric || '';
            if (label.toLowerCase() === 'default title') label = prodFabric || '';
            var widthPart = sv.width || getOptByName(sv, 'width') || '';
            if (widthPart) label += ' · ' + widthPart;
            valEl.textContent = label;
          }
        }
      }

      renderCards();
      var initV = variants.find(function(v) { return v.id === selectedId; });
      if (initV) filterDescription(initV);
    })();

    var buyNowBtn = document.getElementById('btn-buy-now');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        window.location.href = '/cart/' + variantIdInput.value + ':' + (meterInput ? meterInput.value : 1);
      });
    }

    var wishBtn = document.getElementById('btn-wishlist');
    if (wishBtn) {
      var wHandle = wishBtn.dataset.handle;

      function syncWishBtn() {
        var inList = window.__wl && window.__wl.isIn(wHandle);
        wishBtn.classList.toggle('is-wishlisted', inList);
        wishBtn.setAttribute('aria-label', inList ? 'Remove from wishlist' : 'Add to wishlist');
      }

      wishBtn.addEventListener('click', function() {
        if (!window.__wl) return;
        if (window.__wl.isIn(wHandle)) {
          window.__wl.remove(wHandle);
          syncWishBtn();
          if (window.__wl.updateBadges) window.__wl.updateBadges();
        } else {
          window.__wl.add({
            handle: wHandle,
            title: wishBtn.dataset.title || '',
            img: wishBtn.dataset.img || '',
            price: wishBtn.dataset.price || '',
            url: wishBtn.dataset.url || '/products/' + wHandle,
            meta: wishBtn.dataset.meta || '',
            rateUnit: wishBtn.dataset.unit || ''
          });
          syncWishBtn();
          if (window.__wl.updateBadges) window.__wl.updateBadges();
          var wlIcon = document.querySelector('.header__wl-btn');
          var activeSlide = document.querySelector('.product-gallery__slide.is-active .product-gallery__img');
          var flyImg = activeSlide ? (activeSlide.src || activeSlide.currentSrc) : '';
          if (window.__flyTo && wlIcon && flyImg) {
            window.__flyTo(wishBtn, wlIcon, flyImg);
          }
        }
      });

      var waitWl = setInterval(function() {
        if (window.__wl) { clearInterval(waitWl); syncWishBtn(); }
      }, 50);
    }

    var stickyBar = document.getElementById('sticky-atc');
    var productButtons = document.querySelector('.product-buttons');
    if (stickyBar && productButtons) {
      var stickyObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      stickyObserver.observe(productButtons);
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function() { addBtn.click(); });
    }

    /* ── Lightbox ── */
    var lightbox = document.getElementById('product-lightbox');
    var lightboxImg = document.getElementById('lightbox-img');
    var lightboxClose = document.getElementById('lightbox-close');
    var lightboxBody = document.getElementById('lightbox-body');

    if (lightbox && slider) {
      slider.addEventListener('click', function(e) {
        var img = e.target.closest('.product-gallery__img');
        if (!img) return;
        var src = img.src || img.currentSrc;
        src = src.replace(/width=\d+/, 'width=1800');
        lightboxImg.src = src;
        lightboxImg.classList.remove('is-zoomed');
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });

      lightboxClose.addEventListener('click', function() {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });

      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox || e.target === lightboxBody) {
          lightbox.classList.remove('is-open');
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });

      lightboxImg.addEventListener('click', function(e) {
        e.stopPropagation();
        this.classList.toggle('is-zoomed');
      });
    }

    var pForm = document.getElementById('product-form');
    if (pForm) {
      var origAtcHtml = addBtn ? addBtn.innerHTML : '';
      pForm.addEventListener('submit', function(e) {
        if (pForm.dataset.ajaxBypass === 'true') { delete pForm.dataset.ajaxBypass; return; }
        if (pForm.dataset.qtyPresetBypassPending === 'true') return;
        if (pForm.dataset.qtyPresetPendingMapped === 'true') return;
        e.preventDefault();
        var formData = new FormData(pForm);
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding...'; }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(r) { return r.json(); })
        .then(function(item) {
          if (addBtn) { addBtn.textContent = 'Added!'; }
          // let on-page widgets (e.g. BXGY teaser) update without refetching the cart
          document.dispatchEvent(new CustomEvent('cart:added', { detail: item }));
          if (window.__cartAdded) {
            window.__cartAdded(item);
          } else {
            var countEl = document.querySelector('.header__cart-count');
            if (countEl) {
              fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? '' : 'none';
              });
            }
          }
          setTimeout(function() {
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.innerHTML = origAtcHtml;
            }
          }, 1500);
        })
        .catch(function() {
          if (addBtn) { addBtn.disabled = false; addBtn.innerHTML = origAtcHtml; }
        });
      });
    }
  })();
